import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isEmpty } from 'lodash-es';

import { ChangeUserDetailsRequest, Gender } from '@vi-iot/client';

import { PATTERN } from '@common';
import { PersonalDetailsFormGroup } from './personal-details.helper';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalDetailsComponent implements OnInit {
  formGroup: FormGroup<PersonalDetailsFormGroup>;
  genders = Object.values(Gender);

  @Input() userRole: {
    id: string;
    role: string;
    type: string;
  };

  @Input() details: {
    firstName: string;
    lastName: string;
    gender: Gender;
  };

  @Input() isEmailVerified: boolean;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() save: EventEmitter<ChangeUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  ngOnInit(): void {
    this.formGroup = new FormGroup<PersonalDetailsFormGroup>({
      gender: new FormControl<Gender>(this.details.gender),
      firstName: new FormControl<string>(this.details.firstName, [
        Validators.required,
        Validators.pattern(PATTERN.NO_SPACES),
      ]),
      lastName: new FormControl<string>(this.details.lastName, [
        Validators.required,
        Validators.pattern(PATTERN.NO_SPACES),
      ]),
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSave(): void {
    const value = this.formGroup.value;
    const payload: ChangeUserDetailsRequest = {
      name: {
        firstName: value.firstName?.trim(),
        familyName: value.lastName?.trim(),
      },
      gender: value.gender,
    };

    if (isEmpty(payload)) {
      this.onCancel();
    } else {
      this.save.emit(payload);
    }
  }
}
